import { PageConfig } from '../../type';

export const reconductionsABloquerSchema: PageConfig = {
    config: {
        modelName: 'reconductions A Bloquer Pour Assistant Potentiel',
        itemName: 'une reconductions',
        apiUrl: '/views/reconductionABloquerPourAssistantPotentiel',
        options: ['filter', 'order'],
        banExport: ['pdf'],
        // defaultOrder: { ['facture/numeroFacture']: 'asc' },
        // secondarySearch: 'Numero Facture',
        // redirectTo: '/parrainages',
    },

    schemas: [
        {
            style: { width: 180 },
            ref: 'facture/numeroFacture',
            title: 'Numero Facture',
        },
        {
            style: { width: 300 },
            ref: 'personneMorale/raisonSociale',
            title: 'Raison Sociale',
            type: 'HTMLText',
            search: true,
        },
        { style: { width: 180 }, ref: 'telephone', ban: ['order', 'filter'] },
        {
            style: { width: 180 },
            ref: 'personneMorale/adresse/ligne1',
            title: 'Adresse',
        },
        {
            style: { width: 100 },
            ref: 'personneMorale/adresse/NPA',
            title: 'Npa',
            type: 'amount',
        },
        {
            style: { width: 180 },
            ref: 'personneMorale/adresse/region',
            title: 'Localite',
        },
        { style: { width: 180 }, ref: 'dateAccord', type: 'date' },
        { style: { width: 180 }, ref: 'mandat/ref', title: 'Id Club' },
    ],
};

export default reconductionsABloquerSchema;
